export enum InterviewSource {
  EmailAi = 'email_ai',
}
